module.exports = __webpack_public_path__ + "images/45b8aa0eb6d11ee9e6ac166c6fdd972f.png";